<div class="container-fluid px-0 min-vh-100 dynamic-case-report-page">
  <main class="case-report-builder-panel dynamic-case-report-panel">
    <section class="dynamic-report-topbar">
      <div class="dynamic-report-project-actions">
        <button
          type="button"
          class="btn btn-primary-dark case-report-builder-action d-inline-flex align-items-center justify-content-center gap-2"
          @click="save_report_configuration"
        >
          <i class="bi bi-save"></i>
          <span>Save Configuration</span>
        </button>
      </div>
    </section>

    <section class="dynamic-report-tab-panel">
      <fieldset class="case-report-builder-fieldset dynamic-report-fieldset">
        <legend>Select Fields to Include in Report</legend>

        <div class="dynamic-report-field-toolbar">
          <div class="dynamic-report-search-wrap">
            <i class="bi bi-search"></i>
            <input
              v-model="field_search"
              class="form-control case-report-builder-control dynamic-report-search"
              placeholder="Search questions"
              aria-label="Search report fields"
            >
          </div>
          <div class="dynamic-report-actions">
            <button
              type="button"
              class="btn btn-light border secondary-color d-inline-flex align-items-center justify-content-center gap-2"
              :disabled="loading_lookups"
              @click="select_all_fields(filtered_dynamic_fields)"
            >
              <i class="bi bi-check2-square"></i>
              <span>Select Questions</span>
            </button>
            <button
              type="button"
              class="btn btn-light border secondary-color d-inline-flex align-items-center justify-content-center gap-2"
              :disabled="loading_lookups"
              @click="clear_field_selection"
            >
              <i class="bi bi-eraser"></i>
              <span>Clear</span>
            </button>
          </div>
        </div>

        <div class="dynamic-report-columns">
          <section>
            <div class="dynamic-report-section-head">
              <span>All Questions</span>
              <strong>{{ selected_dynamic_count }}</strong>
            </div>

            <div
              v-if="loading_lookups"
              class="dynamic-report-loading"
            >
              <span class="spinner-border spinner-border-sm"></span>
              <span>Loading fields...</span>
            </div>
            <div
              v-else
              class="case-report-builder-check-grid dynamic-report-check-grid dynamic-report-scroll-list"
            >
              <label
                v-for="field in filtered_dynamic_fields"
                :key="`dynamic-${field.key}`"
                class="case-report-builder-check dynamic-report-check dynamic-report-answer-check"
                :class="{ 'is-selected': is_field_selected(field.key) }"
              >
                <input
                  type="checkbox"
                  :checked="is_field_selected(field.key)"
                  @change="toggle_field(field.key)"
                >
                <span>
                  <strong>{{ field.label }}</strong>
                  <small>{{ field.meta }}</small>
                </span>
              </label>
              <p
                v-if="!filtered_dynamic_fields.length"
                class="dynamic-report-empty"
              >
                No backend questions returned for this project.
              </p>
            </div>
          </section>
        </div>
      </fieldset>

    </section>
  </main>
</div>
